import { Container } from './styles';

import DownloadApp from './components/DownloadApp';
import Footer from './components/Footer';
import Header from './components/Header';
import HowItWorks from './components/HowItWorks';
import Seals from './components/Seals';
import Slide from './components/Slide';
import Washes from './components/Washes';

import React from 'react';

/**
 * Página principal da aplicação
 * Exibe componentes da landing page em ordem estruturada
 */
const Index = () => (
  <Container>
    <Header />
    <Slide />
    <Seals />
    <HowItWorks />
    <Washes />
    <DownloadApp />
    <Footer />
  </Container>
);

export default Index;
